import { createAction } from '@reduxjs/toolkit';

export const initializeUpsells = createAction('upsell/initializeUpsells');
export const toggleOptionalUpsellSelectedStatus = createAction(
  'upsell/toggleOptionalUpsellSelectedStatus',
  (itemId, isSelected) => {
    return { payload: { itemId, isSelected } };
  }
);
export const toggleRequiredUpsellSelectedStatus = createAction(
  'upsell/toggleRequiredUpsellSelectedStatus',
  (itemId) => {
    return { payload: { itemId } };
  }
);
export const updateUpsellQuantity = createAction('upsell/updateUpsellQuantity');

export const setCurrentUpsellItemId = createAction('upsell/setCurrentUpsellItemId');
export const setCurrentUpsellsValidationStatus = createAction(
  'upsell/setCurrentUpsellsValidationStatus',
  (invalidItemId, showMessageBox) => {
    return { payload: { invalidItemId, showMessageBox } };
  }
);
export const setCurrentUpsellType = createAction('upsell/setCurrentUpsellType');
export const setOptionalUpsellsExcluded = createAction('upsell/setOptionalUpsellsExcluded');

export const changeUpsellScale = createAction('CHANGE_UPSELL_SCALE');
export const changeUpsellImprintAreaDimension = createAction('CHANGE_UPSELL_IMPRINTAREA_DIMENSION');
export const changeUpsellFontSizesAndUpsellImprintFits = createAction('CHANGE_UPSELL_FONTSIZES_AND_UPSELL_IMPRINTFITS');
export const changeUpsellHeightFits = createAction('CHANGE_UPSELL_HEIGHTFITS');
export const changeUpsellText = createAction('CHANGE_UPSELL_TEXT');
export const changeUpsellFontFace = createAction('CHANGE_UPSELL_FONTFACE');
export const changeUpsellFontCode = createAction('CHANGE_UPSELL_FONTCODE');
export const changeUpsellFontSize = createAction('CHANGE_UPSELL_FONTSIZE');
export const changeUpsellTextStyle = createAction('CHANGE_UPSELL_TEXT_STYLE');
export const changeStyleToAllUpsellText = createAction('CHANGE_STYLE_TO_ALL_UPSELL_TEXT');
export const selectUpsellText = createAction('SELECT_UPSELL_TEXT');
export const unSelectAllUpsellText = createAction('UNSELECT_All_UPSELL_TEXT');
export const updateUpellFullPreviewUrl = createAction('UPDATE_UPSELL_FULL_PREVIEW_URL');
